import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'

export default function About() {
  library.add(fab)

  return (
    <section id="about" className="relative">
      <div className="container mx-auto flex px-5 py-10 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            <br className="hidden lg:inline-block" /> Innovative Senior Machine Learning Engineer
          </h1>
          <p className="mb-8 leading-relaxed">
            Master’s degree from the University of Oulu in computer science and engineering and Bachelor’s in Electronics engineering and embedded systems.
          </p>
          <p className="mb-8 leading-relaxed">
            Over 5 years of experience in software development, machine learning, and data engineering,
            expertise in IoT, Edge AI, and Cloud-based ML solutions. Strong background in data platforms, AI/ML model deployment, and big data processing.
            Passionate about designing scalable and efficient microservices, automation, and DevOps for web, mobile, and IoT applications.
          </p>
          <p className="mb-8 leading-relaxed">
          <ul className="mb-8 leading-relaxed list-disc list-inside">
            <li><strong>AI & ML Expertise:</strong> Deep Learning, Reinforcement Learning, NLP, and Computer Vision.</li>
            <li><strong>IoT & Edge AI:</strong> Experience in deploying ML models on IoT devices, edge computing, and real-time data processing.</li>
            <li><strong>Big Data & Cloud Platforms:</strong> Google Cloud, Azure, AWS, DeltaLake, Hadoop, Spark </li>
            <li><strong>Software Development:</strong> Proficient in Python, Java, C++, and JavaScript frameworks.</li>
            <li><strong>DevOps & Automation:</strong> CI/CD pipelines, containerization (Docker), and orchestration (Kubernetes).</li>
            <li><strong>Web & Mobile Development:</strong> Full-stack development with React, Node.js, and mobile frameworks.</li>
            <li><strong>Database Management:</strong> SQL, NoSQL, and time-series databases.</li>
            <li><strong>3D Formats & Specifications:</strong> Good knowledge of 3D formats and specifications.</li>
          </ul>
          </p>
          <div className="social-links">
            <a href="https://github.com/moamenibrahim" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={['fab', 'github']} fixedWidth size="2x" />
            </a>
            <a href="https://www.linkedin.com/in/moamenibrahim/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={['fab', 'linkedin']} fixedWidth size="2x" />
            </a>
            <a href="https://scholar.google.com/citations?user=0BOWMJsAAAAJ&hl=en" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon="fa-brands fa-google-scholar" fixedWidth size="2x" />
            </a>
          </div>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Hire Me
            </a>
            <a
              href="#projects"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              See My Past Work
            </a>
          </div>
        </div>
        <div className="circular_image lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="rounded"
            alt="Moamen Ibrahim"
            src="./moamen.jpg"
          />
        </div>
      </div>
    </section>
  );
}
